exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.file-upload-section .dropzone .dz-message {\n  margin: 0;\n}\n.file-upload-section .dropzone .dz-preview {\n  vertical-align: top !important;\n  height: 66px !important;\n  top: 3px;\n  width: 91px;\n  margin: 0 !important;\n}\n", "", {"version":3,"sources":["/home/vvikas-fedora-hp/dev/hellopeter/portal/src/pages/collect-reviews/ReviewInviteSends.vue"],"names":[],"mappings":";AACA;EACE,UAAU;CACX;AACD;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,SAAS;EACT,YAAY;EACZ,qBAAqB;CACtB","file":"ReviewInviteSends.vue","sourcesContent":["\n.file-upload-section .dropzone .dz-message {\n  margin: 0;\n}\n.file-upload-section .dropzone .dz-preview {\n  vertical-align: top !important;\n  height: 66px !important;\n  top: 3px;\n  width: 91px;\n  margin: 0 !important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8a0b297e","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/pages/collect-reviews/ReviewInviteSends.vue
// module id = rz7c
// module chunks = 4